import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import './DatePicker.scss';
import { createTheme, ThemeProvider } from '@mui/material';

function DatePicker({
  label,
  value,
  onChange,
  placeholder = 'dd/mm/yyyy',
  disabled = false,
  readOnly = false,
  ...pickerProps
}) {

  const normalizeToDayjs = (dateValue) => {
    if (!dateValue) return undefined
    if (dayjs.isDayjs(dateValue)) return dateValue

    const parsed = dayjs(dateValue)
    return parsed.isValid() ? parsed : undefined
  }

  const normalizedValue = normalizeToDayjs(value) || null
  const normalizedMinDate = normalizeToDayjs(pickerProps.minDate)
  const normalizedMaxDate = normalizeToDayjs(pickerProps.maxDate)

  const newTheme = (theme) => createTheme({
    ...theme,
    components: {
      MuiPickerDay: {
        styleOverrides: {
          today: {
            color: 'white',
            borderColor: '#053F48',
            border: '1px solid',
            backgroundColor: '#053F48',
          }
        }
      }
    }
  })
  const handleChange = (newValue) => {
    const isoString = newValue && dayjs(newValue).isValid()
      ? dayjs(newValue).format('YYYY-MM-DD')
      : null
    if (onChange) {
      onChange(isoString);
    }
  };

  return (
    <ThemeProvider theme={newTheme()}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MuiDatePicker
          label={label}
          value={normalizedValue ? dayjs(normalizedValue) : null}
          onChange={handleChange}
          disabled={disabled}
          readOnly={readOnly}
          {...pickerProps}
          minDate={normalizedMinDate}
          maxDate={normalizedMaxDate}
          format='DD/MM/YYYY'
          slotProps={{
            textField: {
              placeholder,
              fullWidth: true,
              className: 'date-picker-input',
            },
          }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default DatePicker;
